import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import { useEffect, useState } from 'react';
import Button from '../Button';
import MiniLoader from '../MiniLoader/MiniLoader';
import { formatDate } from '@/core/helpers';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  onSubmit: (v: number) => Promise<void>;
  value: number | undefined;
}

export const FisclalYearStartsModal = ({
  isModalOpened,
  closeModal,
  onSubmit,
  value,
}: Props) => {
  const [month, setMonth] = useState<number>();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isModalOpened && value) {
      setMonth(value);
    }
    // eslint-disable-next-line
  }, [isModalOpened]);

  return (
    <Modal
      name='coa-number'
      isOpened={isModalOpened}
      close={closeModal}
      title={t('Fiscal year settings')}
    >
      <div className='mx-4 px-4 pb-6 pt-2'>
        <div className='mb-2 text-h4 font-extrabold'>
          {t('Select the month')}
        </div>
        <div className='mb-2'>
          {t('The first day of each month is considered the start.')}
        </div>
        <div className='mb-6 grid grid-cols-[repeat(3,78px)] gap-2 sm:grid-cols-[repeat(6,78px)]'>
          {Array(12)
            .fill(1)
            .map((_, i) => {
              const date = new Date();
              date.setMonth(i);
              return (
                <Button
                  size='sm'
                  styling={i === month ? 'primary' : 'outline'}
                  key={i}
                  className='block w-full !rounded-full text-center'
                  onClick={() => setMonth(i)}
                  data-testid={`month-${i}`}
                >
                  {formatDate(date, 'MMM')}
                </Button>
              );
            })}
        </div>
        <div className='flex flex-wrap gap-x-2'>
          <div>
            <Button
              className='flex items-center'
              disabled={isLoading}
              data-testid='submit-btn'
              onClick={async () => {
                if (month === undefined) return;
                setIsLoading(true);
                await onSubmit(month);
                setIsLoading(false);
              }}
            >
              {isLoading && <MiniLoader className='mr-2' color='gray' />}
              <span>{t('Update')}</span>
            </Button>
          </div>
          <div>
            <Button
              styling='outline'
              onClick={closeModal}
              disabled={isLoading}
              data-testid='cancel-btn'
            >
              {t('Cancel')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
